// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import PDFPrintSettings from "@bg/App/Components/PdfSettings/PDFPrintSettings";
import { CustomAppState } from "@bg/App/Store/Reducers";
import { parseBoolean } from "@bg/XDL/Utilities";
import { getQuoteState } from "@insite/client-framework/Store/Data/Quotes/QuotesSelector";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import * as React from "react";
import { useMemo } from "react";
import { connect } from "react-redux";

const mapStateToProps = (state: CustomAppState) => ({
    quoteState: getQuoteState(state, state.pages.rfqQuoteDetails.quoteId),
    oldQuoteState: state.xQuoteDetails.quote,
    isLoading: getQuoteState(state, state.pages.rfqQuoteDetails.quoteId)?.isLoading,
});

type Props = WidgetProps & ReturnType<typeof mapStateToProps>;

const RfqQuoteDetailsPDF: React.FC<Props> = ({ id, quoteState, oldQuoteState, isLoading }) => {
    const quote = useMemo(() => {
        return quoteState.value || oldQuoteState;
    }, [quoteState.value, oldQuoteState]);

    const shouldRenderPDF = useMemo(() => {
        return quote && !(isLoading && !quote) && quote?.properties.isExpired && !parseBoolean(quote?.properties.isExpired);
    }, [quote, isLoading]);

    if (!shouldRenderPDF) {
        return null;
    }

    return <PDFPrintSettings showUploadLogo={true} isQuote={true} id={quote?.id || ""} />;
};

const widgetModule: WidgetModule = {
    component: connect(mapStateToProps)(RfqQuoteDetailsPDF),
    definition: {
        group: "XNGAGE" as any,
        displayName: "PDF Settings",
        icon: "Printer",
        allowedContexts: ["RfqQuoteDetailsPage"],
    },
};

export default widgetModule;
